import { handleActions } from 'redux-actions';

import { reportStoreTypes, reportUpserters, resourceUpserters } from '../core';

import * as actions from './accountsBalancesHistoryActions';

const reducer = handleActions(
  {
    // TODO: sanitize any PII information if needed
    // [coreActions.sanitize]: (state) =>
    //   state.set('resourcesById', state.resourcesById.map((resource) => resource.merge({
    //     name: hash(resource.name).toString(),
    //   }))),

    [actions.getAccountsBalancesHistory]: (state) => state.set('isLoading', true),

    [actions.getAccountsBalancesHistorySuccess]: (state, { payload }) => reportUpserters.upsertReports(state, payload),

    [actions.getAccountsBalancesHistoryFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  reportStoreTypes.mkReportStore(),
);

export default reducer;
